import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { msg } from "@lingui/core/macro";
import { getAvailableSocialProviders } from "~/features/auth/auth.queries";
import { normalizePostAuthIntentSearchValue } from "~/features/auth/auth-routing";
import SignupForm from "~/features/auth/components/signup";
import { getI18n } from "~/lib/i18n/i18n";
import { createPageHead } from "~/shared/lib/page-head";

const searchSchema = z.object({
  intent: z.preprocess(normalizePostAuthIntentSearchValue, z.string().optional()),
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/auth/signup")({
  validateSearch: (search) => searchSchema.parse(search),
  loader: async () => ({
    socialProviders: await getAvailableSocialProviders(),
  }),
  head: () => createPageHead(getI18n()._(msg`Sign up`)),
  component: SignupRoute,
});

function SignupRoute() {
  const { intent, redirect } = Route.useSearch();
  const { socialProviders } = Route.useLoaderData() as {
    socialProviders: Awaited<ReturnType<typeof getAvailableSocialProviders>>;
  };
  return (
    <SignupForm
      redirectPath={redirect}
      postAuthIntent={intent}
      socialProviders={socialProviders}
    />
  );
}
